export default {
	"order.TheOrderAddressModificationHasExceededTheMaximumAllowedNumberOfTimes": "The order address modification has exceeded the maximum allowed number of times",
	"order.TheOnlyChanceForTheOrderToModifyTheAddressIsLeft": "The only chance for the order to modify the address is left",
	"order.timesPleaseCheckTheInformationCarefullyBeforeSubmitting": "times, please check the information carefully before submitting",
	"order.PleaseSelectAnItem": "Please select an item",
	"order.deleteFailed": "delete failed",
	"order.AddressModifiedSuccessfully": "Address modified successfully!",
	"order.orderDoesNotExist": "order does not exist",
	"order.ParameterError": "Parameter error!",
	"order.TheNumberOfAddressesThatCanBeModifiedForThisOrderHasBeenExhausted": "The number of addresses that can be modified for this order has been exhausted",
	"order.TheFollowingIsTheDeliveryAddressForPhysicalGoods": "The following is the delivery address for physical goods",
	"order.hint": "hint",
	"order.understood": "understood",
	"order.ModifiedAddressInformation": "Modified address information",
	"order.WhetherTheFollowingProductAddressesAreSynchronouslyModified": "Whether the following product addresses are synchronously modified",
	"order.ModifyingTheAddressOnlyChangesTheLogisticsInformationThatHasNotBeenShipped": "Modifying the address only changes the logistics information that has not been shipped",
	"order.TheNumberOfChangesToTheAddressOfEachOrderMustNotExceed": "·The number of changes to the address of each order must not exceed",
	"order.SecondRate": "Second-rate",
	"order.Cancel": "Cancel",
	"order.ConfirmTheChanges": "Confirm the changes"
}